import { RootState } from "../../../../../redux/store";

export const error = (state: RootState) => state.customerAttachments.error;
export const getErrorAction = (state: RootState) => state.customerAttachments.errorAction;
export const filters = (state: RootState) => state.tasksAttachments.filters;
export const selectedFile = (state:RootState) => state.tasksAttachments.selectedFile;
export const selectedFileLoading = (state:RootState) => state.tasksAttachments.selectedFileLoading;
export const fileDownloading = (state:RootState) => state.tasksAttachments.fileDownloading;